import { COOKIES, removeCookie } from '../cookies';

export const getUrlExtension = (url: string): string | undefined => url.split('?')[0].split('.').pop()?.toLowerCase();

export const injectRegionInDomain = async (domain = '', region: string) => {
    removeCookie(COOKIES.REFERER_REDIRECT);
    return domain.replace(/account/, `account.${region}`);
};

export const removeProductFromUid = (uid: string) => uid.replace(`${process.env.PRODUCT}-`, '');

export const toNativeCategoryUid = (slug: string): string => {
    const product = process.env.PRODUCT as string;
    return slug.startsWith(`${product}-`) ? slug : `${product}-${slug}`;
};

export const getPathFromReferrer = (externalReferrer?: unknown): string | null => {
    if (typeof externalReferrer !== 'string') return null;

    const value = externalReferrer?.trim();
    if (!value) return null;

    // Strips any leading slashes
    const stripped = value.replace(/^\/+/, '');

    // Block absolute URLs (protocol:)
    if (/^[a-z][a-z\d+\-.]*:/i.test(stripped)) {
        return null;
    }
    // Block hostnames like something.com or sub.something.com
    if (/^[^/]+\.[^/]+/.test(stripped)) {
        return null;
    }

    return `/${stripped}`;
};
